<template>
  <span
    class="group relative block w-full text-slate"
    :class="{ 'h-full': fitContainer }"
  >
    <textarea
      v-model="valueLocal"
      type="text"
      class="w-full rounded-lg border-gray-lighten1 px-5 py-3 text-md transition placeholder:text-slate-lighten4 focus:border-slate-lighten4 focus:outline-0 focus:outline-offset-0 focus:ring-0 group-hover:border-gray"
      :class="[
        { 'h-full': fitContainer },
        { '!border-red-lighten1': error },
        { '!border-gray-lighten1 !text-slate-lighten4': disabled },
        textareaClass,
      ]"
      :placeholder="placeholder"
      :maxlength="maxlength"
      rows="4"
    />

    <span
      v-if="maxlength && valueLocal"
      class="absolute bottom-2 right-5 bg-white px-1 leading-tight"
    >
      {{ valueLocal.length }} / {{ maxlength }}
    </span>

    <span v-if="error" class="block py-1 text-red-lighten1">
      {{ error }}
    </span>
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  modelValue?: string;
  modelModifiers?: Record<string, boolean>;
  placeholder?: string;
  maxlength?: string | number;
  fitContainer?: boolean;
  error?: string | null;
  disabled?: boolean;
  textareaClass?: string;
}

interface Emits {
  (e: 'update:modelValue', data: Props['modelValue']): void;
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: undefined,
  modelModifiers: () => ({}),
  placeholder: undefined,
  maxlength: undefined,
  fitContainer: false,
  error: null,
  disabled: false,
  textareaClass: '',
});

const emit = defineEmits<Emits>();

const valueLocal = computed<any>({
  get() {
    return props.modelValue;
  },
  set(newValue) {
    emit('update:modelValue', newValue);
  },
});
</script>
